import GeneralFilter from '../../../../Model/GeneralFilter'

export default class SponsorFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
